var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConvo = function SvgConvo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.833 2.583H5.166a2.583 2.583 0 0 0-2.583 2.584V46.5a2.583 2.583 0 0 0 2.583 2.584h9.042c.713 0 1.292.578 1.292 1.291v8.5a2.583 2.583 0 0 0 1.601 2.402c.313.123.646.185.982.18a2.583 2.583 0 0 0 1.834-.748l10.85-10.876a2.712 2.712 0 0 1 1.834-.75h24.232a2.583 2.583 0 0 0 2.583-2.583V5.167a2.583 2.583 0 0 0-2.583-2.583ZM38.75 31H18.083v-2.583H38.75V31Zm7.75-10.333H18.083v-2.584H46.5v2.584Z",
    fill: "#D1CBCB"
  })));
};
export default SvgConvo;